module.exports = __webpack_public_path__ + "media/newstyle/images/completed-purchase-book-aus-0840f9bb05852e5d4e949713cc573eca.png";